import template from './sw-extension-card-base.html.twig';

export default Shopware.Component.wrapComponentConfig({
    template,
});
